import { IUserData } from '../../types/interfaces';
import { ActionTypes } from '../types/actionTypes';
import { ISetAuth, ISetUserData } from '../types/actions';

export const setAuth = (payload: boolean): ISetAuth => ({
  type: ActionTypes.SET_AUTH,
  payload,
});

export const setUserData = (payload: IUserData): ISetUserData => ({
  type: ActionTypes.SET_USER_DATA,
  payload,
});

export const setSectionId = (payload: any) => ({
  type: ActionTypes.SET_SECTION_ID,
  payload,
});
